import type { ReactNode } from 'react';
import { ApiRequestError } from '../lib/api';

export function ErrorAlert({ error }: { error: unknown }) {
  if (!error) return null;
  const message =
    error instanceof ApiRequestError
      ? error.message
      : error instanceof Error
        ? error.message
        : 'เกิดข้อผิดพลาดที่ไม่ทราบสาเหตุ';

  const details =
    error instanceof ApiRequestError && Array.isArray(error.details)
      ? (error.details as Array<{ path: string; message: string }>)
      : null;

  return (
    <div className="alert error" role="alert">
      <div>{message}</div>
      {details && (
        <ul style={{ margin: '6px 0 0', paddingInlineStart: 18 }}>
          {details.map((d, i) => (
            <li key={i} className="small">
              {d.path}: {d.message}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}

export function Loading({ label = 'กำลังโหลด…' }: { label?: string }) {
  return (
    <div className="empty" role="status">
      {label}
    </div>
  );
}

export function Empty({ children }: { children: ReactNode }) {
  return <div className="empty">{children}</div>;
}

const STATUS_TONE: Record<string, string> = {
  active: 'green',
  monitoring: 'blue',
  screening: 'amber',
  graduated: 'green',
  closed: '',
  rejected: 'red',
  deceased: '',
  invited: 'amber',
  suspended: 'red',
  resigned: '',
  low: 'green',
  medium: 'amber',
  high: 'red',
  critical: 'red',
};

export function Badge({ value, label }: { value: string; label: string }) {
  const tone = STATUS_TONE[value] ?? '';
  return <span className={`badge ${tone}`}>{label}</span>;
}

export function Modal({
  title,
  onClose,
  children,
}: {
  title: string;
  onClose: () => void;
  children: ReactNode;
}) {
  return (
    <div
      className="modal-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label={title}
      onClick={(e) => {
        if (e.target === e.currentTarget) onClose();
      }}
    >
      <div className="modal">
        <h2>{title}</h2>
        {children}
      </div>
    </div>
  );
}
